---
title: An Approach to Assemble Software Products Using a Product Line Approach
slug: assemble-software-products-product-line
type: paper
status: published
featured: true
summary: How a product-line approach changes the way software products are assembled rather than built one at a time.
sitePublishedAt: "2026-09-18"
originalPublishedAt: "2003-01-01"
lastReviewedAt: "2026-09-18"
audiences:
  - product-developer
themes:
  - product-lines
sourceUrl: https://www.researchgate.net/profile/Jay-Van-Zyl
originalAuthor: Jay van Zyl
sourceRelationship: academic record listed on ResearchGate
rightsStatus: outbound-only
seoDescription: 2003 paper by Jay van Zyl on assembling software products with a product-line approach.
canonicalPath: /research/assemble-software-products-product-line
authors:
  - Jay van Zyl
year: 2003
venue: ResearchGate record
publicationType: article
citation: "van Zyl, J. (2003). An Approach to Assemble Software Products Using a Product Line Approach."
researchTheme: application-assembly
recordUrl: https://www.researchgate.net/profile/Jay-Van-Zyl
---

Takeaway: product-line assembly is the industrial version of what EcosystemCode later automates. Record: [ResearchGate profile](https://www.researchgate.net/profile/Jay-Van-Zyl).
